import { useState } from "react";
import { INftAsset } from "../../../../interfaces"

interface NftDetailProfileProps {
  nftAsset: INftAsset;
}
export const NftDetailProfile = ({ nftAsset }: NftDetailProfileProps) => {
  const [expand, setExpand] = useState<Boolean>(true);
  return (
    <>
      <div className="d-flex justify-content-between align-items-center border-up p-3 cursor-pointer" onClick={() => {
          setExpand(!expand);
        }}>
        <div className="">
          <span className="material-icons-outlined mr-2" style={{ verticalAlign: 'bottom', }}>label</span>
          <span className="weight-600">細節</span>
        </div>
        <span className="material-icons-outlined text-gray-400">{expand ? 'expand_less' : 'expand_more'}</span>
      </div>
      <div 
        className="bg-gray-50 border-up w-100 txt-14 text-justify transition-all duration-700 overflow-y-auto"
        style={{ height: expand ? 'auto' : '0px', padding: expand ? '24px' : 0 }}>
        {nftAsset.contractAddress && <div className="d-flex justify-content-between mt-2">
          <div>Contract Address</div>
          <div>{nftAsset.contractAddress}</div>
        </div>}
        <div className="d-flex justify-content-between mt-2">
          <div className="text-nowrap mr-3">Token ID</div>
          <div className="text-end">{nftAsset.nftId}{nftAsset.tokenId}</div>
        </div>
        <div className="d-flex justify-content-between mt-2">
          <div>Token Standard</div>
          <div>ERC-721</div>
        </div>
        <div className="d-flex justify-content-between mt-2">
          <div>Blockchain</div>
          <div>{nftAsset.chainType}</div>
        </div>
        <div className="d-flex justify-content-between mt-2">
          <div>使用費</div>
          <div>3%</div>
        </div>
        <div className="d-flex justify-content-between mt-2">
          <div>平台費</div>
          <div>9%</div>
        </div>
      </div>
    </>
  )
}